import * as React from 'react';

// Use this provider to add graphql endpoints and other API data calls that are needed for display components in the sandbox.
// This provider will not be rendered in production.
const SandboxDataProvider = ({ children }: React.PropsWithChildren<{}>) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default SandboxDataProvider;
